module.exports = __webpack_public_path__ + "static/ayaka-banner-32646fe510f62b0ba1334979f15c1b08.png";